module.exports = __webpack_public_path__ + "img/icon-interest.fa9120f5.png";